import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

export const getPublishedPost = createServerFn({ method: "GET" })
  .inputValidator((input) =>
    z.object({ slug: z.string().trim().min(1).max(200).regex(/^[a-z0-9-]+$/) }).parse(input),
  )
  .handler(async ({ data }) => {
    const { data: row, error } = await supabaseAdmin
      .from("blog_posts")
      .select(
        "id, slug, title, excerpt, content, cover_url, published_at, updated_at, author_name, author_title, author_bio, author_avatar_url, reading_minutes, focus_keyword, meta_description, keywords, tldr, faq",
      )
      .eq("slug", data.slug)
      .eq("published", true)
      .maybeSingle();
    if (error) {
      console.error("[blog public]", error);
      throw new Error("Kunde inte hämta inlägget.");
    }
    return { post: row };
  });

export const listPublishedPostSlugs = createServerFn({ method: "GET" }).handler(async () => {
  const { data, error } = await supabaseAdmin
    .from("blog_posts")
    .select("slug, published_at")
    .eq("published", true)
    .order("published_at", { ascending: false });
  if (error) {
    console.error("[blog slugs]", error);
    return { posts: [] as Array<{ slug: string; published_at: string | null }> };
  }
  return { posts: data ?? [] };
});

const POST_CARD_FIELDS =
  "id, slug, title, excerpt, meta_description, cover_url, published_at, reading_minutes, keywords, focus_keyword";

export const listPublishedPosts = createServerFn({ method: "GET" }).handler(async () => {
  const { data, error } = await supabaseAdmin
    .from("blog_posts")
    .select(POST_CARD_FIELDS)
    .eq("published", true)
    .order("published_at", { ascending: false });
  if (error) {
    console.error("[blog list]", error);
    return { posts: [] as any[] };
  }
  return { posts: data ?? [] };
});

export const getRelatedPosts = createServerFn({ method: "GET" })
  .inputValidator((input) =>
    z
      .object({
        slug: z.string().trim().min(1).max(200).regex(/^[a-z0-9-]+$/),
        keywords: z.array(z.string().max(80)).max(12).optional(),
      })
      .parse(input),
  )
  .handler(async ({ data }) => {
    const { data: rows, error } = await supabaseAdmin
      .from("blog_posts")
      .select(POST_CARD_FIELDS)
      .eq("published", true)
      .neq("slug", data.slug)
      .order("published_at", { ascending: false })
      .limit(60);
    if (error || !rows) {
      if (error) console.error("[blog related]", error);
      return { posts: [] as any[] };
    }
    const want = new Set((data.keywords ?? []).map((k) => k.toLowerCase()));
    const scored = rows.map((r: any) => {
      const own: string[] = [...(r.keywords ?? []), r.focus_keyword].filter(Boolean);
      const score = own.reduce((n, k) => (want.has(String(k).toLowerCase()) ? n + 1 : n), 0);
      return { post: r, score };
    });
    scored.sort((a, b) => b.score - a.score);
    return { posts: scored.slice(0, 3).map((s) => s.post) };
  });

